import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import PageBar from "../../components/dashboard/page-bar/PageBar";
import LocationList from "../../components/location/locationList/LocationList";
import axios from "axios";
import { Loaders } from "../Loaders";

function LocationListPage() {
  const [loader, setLoader] = useState(false)
  const [data, setData] = useState();
  const [count, setCount] = useState(10)
  const [page, setPage] = useState(1)

  const [initialVlue, setInitialVlue] = useState({
    search: '',
  })
  const handleChange = (e) => {
    const clone = { ...initialVlue }
    const value = e.target.value
    const name = e.target.name
    clone[name] = value
    setInitialVlue(clone)
  }
  const getLocationData = async (page) => {
    setLoader(true)
    const clone = { ...initialVlue, page: page, count: count }
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/location/all?count=${clone?.count}&page=${clone?.page}&search=${clone?.search}`
      );
      setData(res.data);
      setLoader(false)
    } catch (error) { }
  };
  const reset = async (page) => {
    setLoader(true)
    const clone = { search: '', page: page, count: count }
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/location/all?count=${clone?.count}&page=${clone?.page}&search=${clone?.search}`
      );
      setData(res?.data);
      setInitialVlue({
        search: ''
      })
      setLoader(false)
    } catch (error) { }
  }

  useEffect(() => {
    getLocationData(1);
  }, []);
  const onChangeVal = (e) => {
    // console.log(e);
    getLocationData(e)

  };


  return (
    <>
      {loader && <Loaders />}
      <Helmet>
        <title>Location List</title>
        <meta name="keyword" content="Jobs, Find Job, Give " />
        <meta name="description" content="" />
      </Helmet>
      <div className="pageWrapper">
        <PageBar title="Location / City" />
        <h3 className="page-title">
          Manage Location / City
        </h3>
        <LocationList data={data} getLocationData={getLocationData} onChangeVal={onChangeVal} initialVlue={initialVlue} handleChange={handleChange} reset={reset} />
      </div>
    </>
  );
}

export default LocationListPage;
